// extracted by mini-css-extract-plugin
export var button = "buttonComponent-module--button--03474";
export var button__buttonImage = "buttonComponent-module--button__buttonImage--5a67a";
export var button__buttonImageBox = "buttonComponent-module--button__buttonImageBox--a31c8";
export var button__buttonText = "buttonComponent-module--button__buttonText--e29d3";
export var button__cursor = "buttonComponent-module--button__cursor--f66c7";